export const devVariables = {
    ionicEnvName: 'dev',

    loopbackApiVersion: 'api',

    //url del MD de la documentacion
    faqUrl: 'http://documentacionvaltalia.alialabs.com/mdwiki.html#!index.md',

    // id de la playstore
    appPlayStoreId: 'com.alialabs.valtalia',

    // Enviar logs a sentry
    sentryEnabled: false,

    // url de loopback
    loopbackBaseUrl: 'https://devapi.valtalia.alialabs.com',
    //loopbackBaseUrl: 'http://localhost:3050',

    hosts: [
        {order: 0, id: 'sogapol_production', name: 'Sogapol Producción'},
        {order: 1, id: 'belgica_production', name: 'Bélgica Producción',},
        {order: 2, id: 'belgica_test', name: 'Bélgica Test'},
        {order: 3, id: 'sogapol_test', name: 'Sogapol Test'}
        //{order: 4, id: 'sidro', name: 'Sidro Des'},
    ]

};



// WEBPACK FOOTER //
// ./envioronment-variables/development.ts